import React from "react";
import TheLayout from "../components/TheLayout";

export default () => {
    return (
        <TheLayout>
            Hello
        </TheLayout>
    )
}